export default "__VITE_ASSET__hot4uWjEQg5_8jo1Z7BIZQ__"